import { Pipe, PipeTransform } from '@angular/core';
import { TrackingData } from '../providers/tracking';
import { Observable } from 'rxjs/Observable';

@Pipe({
  name: 'getCouponMatch'
})

export class CouponMatchPipe implements PipeTransform {

  constructor(
    private tracking: TrackingData,
  ) {}

  transform(coupon: any, clientId: string, userId: string): any {
    if (coupon.ai) {
      return Observable.of(coupon);
    } else {
      return this.tracking.findEntityById(clientId, userId, coupon.id, 'coupons')
        .map(result => result.data);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/coupons-ai.pipe.ts